var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    className: "menu-buttons__icon--x8Fb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.967 13.95c-1.523.155-3.15-.041-4.845-.774a10.23 10.23 0 01-5.298-5.298c-.732-1.695-.929-3.321-.775-4.845a1.005 1.005 0 00-1.447-1.005C4.988 3.8 2.599 7.682 3.056 12.072c.482 4.625 4.247 8.39 8.872 8.872 4.391.457 8.272-1.932 10.044-5.546a1.004 1.004 0 00-1.005-1.447M12.999 19c-.284 0-.573-.015-.864-.045-3.66-.381-6.708-3.43-7.09-7.09-.292-2.804.85-5.45 2.979-7.125a11.83 11.83 0 00.964 3.93 12.289 12.289 0 006.341 6.342c1.278.553 2.598.877 3.931.964A7.93 7.93 0 0112.999 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.c1556354ff40c3c54bc0ced0b83d49f3.svg";
export { ForwardRef as ReactComponent };